import styled from 'styled-components';

export const TabContent = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Tabs = styled.div`
  overflow: hidden;
  background: #fff;
  font-family: Barlow Condensed;
  font-weight: 600;
  height: 3.5em;
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    overflow: visible;
    background: #fff;
    height: 7em;
    padding: 10px;
  }
`;

export const SectionTitle = styled.p`
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 15px;
  margin-top: 15px;
`;

export const ResponsiveRow = styled.div`
  margin-left: -15px;
  margin-right: -15px;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: normal;
  justify-content: flex-start;

  @media (max-width: 768px) {
    box-sizing: border-box;
    min-height: 1px;
    position: relative;
    padding-left: 0px;
    padding-right: 0px;
    flex: 1 0 0px;
    max-width: 100%;
    margin-left: 0%;
    margin-right: 0%;
    right: auto;
    left: auto;
    display: inline;
  }
`;

export const GridContainer = styled.div`
  margin-left: -15px;
  margin-right: -15px;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: normal;
  justify-content: flex-start;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 16px; /* adjust spacing between grid items */
    width: 100%;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
`;

export const ResponsiveCol = styled.div`
  box-sizing: border-box;
  min-height: 1px;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  flex: 1 0 0px;
  max-width: 100%;
  margin-left: 0%;
  right: auto;
  left: auto;

  @media (max-width: 768px) {
    padding-top: 5px;
    padding-bottom: 5px;
  }
`;

export const Tab = styled.button.attrs({ type: 'button' })`
  border: none;
  color: ${(props) => (props.active ? '#FE5000' : '#000000')};
  outline: none;
  cursor: pointer;
  width: ${(props) => (props.width ? props.width : '12%')};
  position: relative;
  margin-right: 0.1em;
  font-size: 1em;
  font-weight: bold;
  border-bottom: ${(props) => (props.active ? '3px solid #FE5000' : '')};
  background-color: ${(props) => (props.active ? 'white' : 'white')};
  height: ${(props) => (props.active ? '3em' : '2.6em; top:.4em')};
  transition: background-color 0.5s ease-in-out;
  font-family: Barlow Condensed;
  :hover {
    background-color: white;
  }

  @media (max-width: 768px) {
    width: ${(props) => (props.width ? props.width : '12%')};
    font-size: 0.8em;
  }
`;

export const AddUpdateBtn = styled.button.attrs({ type: 'submit' })`
  border: none;
  margin-bottom: 5px;
  color: #fff;
  outline: none;
  cursor: pointer;
  width: 14%;
  position: relative;
  margin-right: 0.5em;
  font-size: 1em;
  font-weight: bold;
  background-color: #fe5000;
  border-radius: 5px;
  height: ${(props) => (props.active ? '3em' : '2.6em; top:.4em')};
  transition: background-color 0.5s ease-in-out;
  font-family: Barlow Condensed;

  @media (max-width: 768px) {
    width: 70%;
    font-size: 1em;
    margin: 0 15vw;
  }
`;

export const Content = styled.div`
  ${(props) => (props.active ? '' : 'display:none;')}
  margin: 20px;
  padding-block: 20px;
`;

export const HeaderMain = styled.div`
  padding: 20px;
  background-color: #f4f4f4;
`;

export const MainRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  @media only screen and (min-width: 768px) {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 600px) {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }
`;

export const StyledText = styled.div`
  font-size: 20px;
  color: #000000;
  text-align: center;
  padding-block: 4px;
  margin: 4px;
  font-family: Barlow Condensed;
  font-weight: 600;
  font-size: 1.8vw;
`;

export const Title = styled.p`
  color: #000000;
  font-family: Barlow Condensed;
  font-weight: 600;
  font-size: 1vw;
  margin-block: 10px;
`;

export const PriceText = styled.p`
  color: #a5a5a5;
  font-family: Barlow Condensed;
  font-weight: 600;
  font-size: 1vw;
  margin-block: 10px;
`;

export const AmountRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-block: 20px;
`;

export const Line = styled.hr`
  color: rgba(169, 169, 169, 0.65);
`;

export const Header = styled.div`
  @media (max-width: 768px) {
    padding-top: 0px;
    min-height: 25vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const EventBody = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;

export const SideBarMain = styled.div`
  background-color: #ffffff;
  width: 30%;
  padding: 40px;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    width: 94%;
    padding: 16px;
    alignitems: center;
    justifycontent: center;
  }
`;

export const CardText = styled.div`
  margin-bottom: 20px;
  display: flex;
  text-align: end;
  width: 20%;

  svg {
    margin-left: 10px;
  }

  @media (max-width: 600px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
`;

export const EventHeaderSection = styled.div`
  ${(props) => (props.styles ? props.styles : 'width: 30%')}
  padding: 40px;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    width: 94%;
    padding: 16px;
    alignitems: center;
    justifycontent: center;
  }
`;
